/* eslint-disable */
import React, { useContext } from "react";
import { AuthContext } from "../contexts/Contexts";

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (!context) {
      throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
  };

/* eslint-enable */